import React, { Component } from 'react';
import './footer.css'


class Footer extends Component {
    constructor(props) {
        super(props)

    }
    render() {

        return (
            <div className='Footer'  >
                    <ul className='FooterList'>
                    
                        <li><a href='https://github.com/muhazzib' target='_blank'>Github</a></li>
                        <li><a href='https://stackoverflow.com/users/7480699/muhazzib-ud-din-farooqui' target='_blank'>Stackoverflow</a></li>
                        <li><a href='https://www.facebook.com/muhazzibuddinfarooqui' target='_blank'>Facebook</a></li>
                        <li><a href='https://plus.google.com/102359660274560477403' target='_blank'>Google+</a></li>
                        <li><a href='https://medium.com/@muhazzib7' target='_blank'>Medium</a></li>
                    </ul>
            </div>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/footer/footer.js